module.exports = __webpack_public_path__ + "static/img/blue_1.cac9a91.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/blue_1.png
// module id = coUr
// module chunks = 1